
import axios from 'axios'
import Cannonicalize from './Cannonicalize'
import Analytics from './Analytics';


const NAMESPACE = ''

var affiliate= 'kotv'
if(typeof window === 'object')
  if(window.location.origin.indexOf('kwtv') > -1 || window.location.origin.indexOf('news9') > -1)
    affiliate = 'kwtv'

var affiliateAlreadySet=false

/* Namespace allows us to move past cache already in circulation, should we ever need ot
The philsophy behind this controller, is it prevents have a separate controller for each client-side cache
"Cannonicalize" contains all the reducers that each feed goes through, please keep in mind they are used
server-side as well
EVERY cacheType must have a reducer in Cannonicalize
*/

// NOTE: Need a helper function to clean our cache periodically, based on localStorage.key()

var cacheTypes ={
  zipCode:{
    duration: 90 * 24 * 60 * 60 //this is in seconds for cookies
  },
  traffic: {
    source: function(options){
      return `https://ftpcontent.worldnow.com/${affiliate}/custom/tracking/traffic.js`
    },
    duration: 1000*10,
    fake: typeof testTraffic === 'object' ? testTraffic : null,
    callbackName: 'traffic',
    dataType: 'jsonp'
  },
  election:{
    source: function(options){
      return `https://ftpcontent.worldnow.com/kotv/custom/elections/election-${affiliate}.js`
    },
    duration: 1000*30,
    fake: typeof testElection === 'object' ? testElection : null,
    callbackName: 'elections_data',
    dataType: 'jsonp'
  },
  schoolClosing:{
    source: function(options){
      return `http://kotv.com/api/GetClosings.ashx?station=${affiliate}&cmd=allclosings&type=json`
    },
    duration: 1000*30,
    fake: typeof testClosings === 'object' ? testClosings : null,
    dataType: 'json'
  },
  category:{
    source: function(options){
      return `http://kotv.api.franklyinc.com/category/${options.id}/a?clienttype=container.json`
    },
    fake: typeof testCategory === 'object' ? testCategory : null,
    duration: 1000*10,
    dataType: 'json'
  },
  story:{
    source: function(options){
      return `http://kotv.api.franklyinc.com/story/${options.id}/a?clienttype=container.json`
    },
    duration: 1000*10,
    dataType: 'json'
  },
  seismograph:{
    source: function(options){
      return 'https://ftpcontent.worldnow.com/kwtv/custom/earthquake/data.json'
    },
    duration: 5*60*1000,
    dataType:'jsonp',
    callbackName:'EarthquakeData'
  },
  earthquake:{
    source: function(options){
      return 'https://ftpcontent.worldnow.com/kwtv/custom/earthquake/'+ options.filename
    },
    duration: 1000*20,
    dataType: 'jsonp',
    callbackName: 'EarthquakeHistory' //yes, seriously, but this is not a 'history' -> it is a seismograph recording

  },
  earthquakeHistory:{
    source: function(options){
      return 'https://ftpcontent.worldnow.com/kwtv/custom/earthquake/earthquakehistory.json'
    },
    duration:60*60*1000,
    dataType: 'jsonp',
    callbackName: 'EarthquakeManifest'
  },
  forecast:{
    source: function(options){
      let site = affiliate === 'kotv' ? '1': '2'
      return `https://kotv.com/api/GetForecast.ashx?target=data&action=WxForecast2012&site=${site}&zip=${getZip()}`
    },
    duration: 1000* 60,
    dataType: 'xml',
  },
  weatherAlert:{
    source: function(options){
      return 'https://kotv.com/api/GetWxEvents.ashx?type=json&cmd=AppEvents&id=4&station=' + affiliate
    },
    duration: 60*1000,
    fake:  typeof testWeatherAlert === 'object' ? testWeatherAlert : null,
    dataType: 'jsonp',
    callbackName: 'jsonCallback',
  },
  skyCam:{
    source: function(options){
      return `https://kotv.com/api/getLiveCams.aspx?station=${affiliate}`
    },
    duration: 1000*3*60,
    dataType: 'json',
  },
  banner : {
    source: function(options){
      return 'https://kotv.com/api/getBanners.aspx?&station=' + affiliate
    },
    duration: 60* 1000,
    fake:  typeof testBanner === 'object' ? testBanner : null,
    dataType: 'json',

  },
  lakeLevel: {
    source: function(options){
      return 'https://water.weather.gov/ahps2/rss/obs/hsko2.rss'
    },
    duration: 60*60*1000,
    dataType: 'xml'
  },
  burnBan: {
    source : function(options){
      return 'https://alerts.weather.gov/cap/ok.php?x=0'
    },
    duration: 60*60*1000,
    dataType:'xml'
  },
  botSources: {
    source : function(options){
      return 'https://ftpcontent.worldnow.com/griffin/BOT/url.txt'
    },
    duration: 60*60*1000,
    dataType:'jsonp',
    callbackName:'botSources'
  },
  almanac:{
    source: function(options){
      function formattedDate(date){

        // date.setDate(date.getDate() + 1 ); //seriously, this feed gives to the almanac for the day BEFORE. how annoying
        let year = date.getFullYear();
        let month = date.getMonth() +1;
        let day = date.getDate();
        if (month < 10){ month = `0${month}`; }
        if (day < 10){ day = `0${day}`; }
        return `${year}-${month}-${day}`;
      }
      return 'https://almanac.feeds.wdtinc.com/feeds/news9/almanac.php?'+ 'ZIP=' + getZip() + '&DATE=' + formattedDate(options.date || new Date())
    },
    duration: 1000 * 60 * 60,
    fake:  typeof testAlmanac === 'object' ? testAlmanac : null,
    promise: false,
    dataType: 'xml',
  }
}

function setAffiliate(a){
  if(affiliateAlreadySet)
    return false
  if(a==='kotv' || a==='kwtv'){
    affiliate = a
    affiliateAlreadySet = true
    if(typeof window === 'object')
      console.log(affiliate === 'kotv' ? 'Welcome to the News on 6' :'Welcome to News 9')
    return true
  }
  return false
}

function getAffiliate(){
  return affiliate
}

function clear(name,options){
  if(!cacheTypes.hasOwnProperty(name))
    throw new Error('undefined cacheType')

  cacheTypes[name].promise = false;

  let countRemoved = 0
  let keys = Object.keys(localStorage)
  keys.map(function(k,i,a){
    if(k.indexOf(NAMESPACE + affiliate + '.' + name) != -1){
      localStorage.removeItem(k+ '.expires')
      localStorage.removeItem(k)
      countRemoved++
      console.log('cleared %s from localStorage',k)
    }

  })

  return true
}

function cacheKey(name,options){
  //keep in mind to update cachecleaner if this changes
  return NAMESPACE + affiliate + '.' + name + ( options ? JSON.stringify(options) : '')
}



function expiresKey(name,options){
  return cacheKey(name,options)+ '.expires'
}

function get(name,options){
  if(typeof window != 'object')
    return
  if(!options)
    options = {debug: false}

  if(!cacheTypes.hasOwnProperty(name))
    throw new Error('undefined cacheType')
  if(options.debug === true)
    return new Promise((resolve,reject)=>{
      console.warn( name + ' is using fake data')
      resolve(Cannonicalize[name](cacheTypes[name].fake))
    })

  if(cacheTypes[name].promise instanceof Promise && JSON.stringify(cacheTypes[name].options) == JSON.stringify(options)){//in case its a duplicate of a request in progress
    return cacheTypes[name].promise
  }


  cacheTypes[name].promise = new Promise((resolve,reject)=>{
      try{
        let cache = localStorage.getItem((cacheKey(name,options)))
        let expiry = localStorage.getItem(expiresKey(name,options));
        if(cache && expiry){
          if( Date.now() < parseInt(expiry,10)){
            resolve( JSON.parse(cache))
            return true;
          }
        }
      } catch(e){
        e.message += '*Back-end* seen in ClientSideCacheController'
        Analytics.reportError(e)
        reject(e || new Error('something went wrong in ClientSideCacheController while fetching ' + name))
      }
      if(!axios)
        throw new Error('AXIOS does not exist here')
      var url = cacheTypes[name].source(options)
      if(cacheTypes[name].dataType === 'json')
        getJson(name,options,resolve)
      else if(cacheTypes[name].dataType === 'xml')
        getXML(name,options, resolve)
      else if(cacheTypes[name].dataType === 'jsonp')
        getJSONP(name,options,resolve)
      else{
        throw new Error('undefined dataType for ' + name + ' in ClientSideCacheController')
      }
    });
  cacheTypes[name].options = options
  return cacheTypes[name].promise

}

function getJson(name,options,resolve){
  let url = cacheTypes[name].source(options)
  axios.get(url).then((res)=>{
  //  validateContentType(res,'application/json')
    let cannonical = Cannonicalize[name](res.data)
    localStorage.setItem(cacheKey(name,options), JSON.stringify(cannonical))
    localStorage.setItem(expiresKey(name,options),Date.now()+cacheTypes[name].duration)
    resolve( cannonical )
  }).catch(httpErrorHandler)
}

function getXML(name,options,resolve){
  let url = cacheTypes[name].source(options)

  axios.get(url).then((res)=>{
  //  validateContentType(res,'text/xml')
    let cannonical = Cannonicalize[name](res.data)
    localStorage.setItem(cacheKey(name,options), JSON.stringify(cannonical))
    localStorage.setItem(expiresKey(name,options),Date.now()+cacheTypes[name].duration)
    resolve( cannonical )
  }).catch(httpErrorHandler)
}

function getJSONP(name,options,resolve){
  var jsonpElement= null;
  if(typeof window === 'object'){ //jsonp call
    window[cacheTypes[name].callbackName] = function(data){ //this is the arbitrarily names jsonp callback
      let cannonical = Cannonicalize[name]( data )
      localStorage.setItem(cacheKey(name,options), JSON.stringify(cannonical))
      localStorage.setItem(expiresKey(name,options),Date.now()+cacheTypes[name].duration)
      jsonpElement = null;
      this.resolve(cannonical)
    }.bind({resolve: resolve}) //attatched to window, with our resolution function bound to it

    jsonpElement = document.createElement('script');
    jsonpElement.className = 'gnm-script'
    jsonpElement.setAttribute('src', cacheTypes[name].source(options));
    document.body.appendChild(jsonpElement);


  }

}

function httpErrorHandler(error){
  if (error.response) {
   // The request was made and the server responded with a status code
   // that falls out of the range of 2xx
   console.log(error.response.data);
   console.log(error.response.status);
   console.log(error.response.headers);
  } else if (error.request) {
   // The request was made but no response was received
   // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
   // http.ClientRequest in node.js
   console.log(error.request);
  } else {
   // Something happened in setting up the request that triggered an Error
   console.log('Error', error.message);
  }
  console.log(error.config);
  let e = new Error('*Back-end* ' + error.request.responseURL + ' responded ' + (error.response.status || 'no response') + ' ')
  Analytics.reportError(e)
}

/* Location data is part of the same controller, all belwo */
function defaultZip() {
  return affiliate == 'kotv' ? "74120" : "73179";
}


function getZip() {
  if (typeof window !== 'object')
    return defaultZip()
  //only on browser
  var currentZip = localStorage.getItem(cacheKey('zipCode'))
  if (currentZip) {
    setZip(currentZip)
    return currentZip
  } else {
    setZip(defaultZip())
    return defaultZip()
  }

}

function validateContentType(res,type){
    if(res.headers['content-type'].indexOf(type) > -1)
      return
    let error = new Error('*Back-end* ' + res.request.responseURL + ' content-type '+type+' was requested, response was content-type ' + res.headers['content-type'])
    Analytics.reportError(error)
}

function setZip(zip) {

  //document.cookie = `${cacheKey('zipCode')}=${zip}; max-age=${cacheTypes.zipCode.duration};`;
  try {
    localStorage.setItem(cacheKey('zipCode'), zip);
  } catch (e) {}
}

function clearZip(){
  localStorage.removeItem(cacheKey('zipCode'))
}

function getGeoLocation(callback){
// Try HTML5 geolocation.
  if(typeof window !== 'object')
    return false
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      var pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      console.log('geolocated to ', pos)
      let maxAge = 90 * 24 * 60 * 60
      //document.cookie = `${cacheKey('geoLocationLat')}=${pos.lat}; max-age=${maxAge};`;
      //document.cookie = `${cacheKey('geoLocationLng')}=${pos.lng}; max-age=${maxAge};`;
      callback(pos)
      return true
    }, function() {
      handleLocationError(true,callback);
    });
  } else {
    // Browser doesn't support Geolocation
    handleLocationError(false,callback);
  }
}

function handleLocationError(browserHasGeolocation,callback) {
 callback(false)
 var message = browserHasGeolocation ? 'Your Browser Has GeoLocation ' : "Your Browser Doesn't Have GeoLocation "
 console.error(message)
}

function cacheCleaner(){

  let countRemoved = 0
  let keys = Object.keys(localStorage)

  keys.map(function(k,i,a){
    if(k.indexOf(affiliate) === 0 && k.indexOf('expires') === k.length - 7){
      let foundOurCacheName = k.slice(5,k.length - 8)
      if(parseInt(localStorage.getItem(k),10) < Date.now()){

        localStorage.removeItem(affiliate + '.' + foundOurCacheName+ '.expires')
        localStorage.removeItem(affiliate + '.' + foundOurCacheName)
        countRemoved++
      }
    }
  })
  console.log('ClientSideCacheController has started as %s, and flushed %s expired keys from localStorage',affiliate, countRemoved )

}

function log(){
  console.log('affiliate', getAffiliate())
  console.log('zip', getZip())
  if(!console.table)
    return


  console.table(cacheTypes)
}


if(typeof window ==='object'){
    window.ClientSideCacheController = {setAffiliate, getAffiliate, get,clear,clearZip, getZip, setZip,getGeoLocation,log}
    cacheCleaner()
}


export default {setAffiliate, get,clear,clearZip, getZip, setZip,getGeoLocation,log}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/ClientSideCacheController.js